import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

const VAT_DEDUCTIBLE_OPTIONS: { id: string; name: string }[] = [
  { id: "true", name: "masterdata:VatDeductibleYesOption" },
  { id: "false", name: "masterdata:VatDeductibleNoOption" },
];

export class VehicleValuationVatFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id: string = "vatDeductible";
  readonly labelSingular = "fab:Vat";
  readonly labelPlural = "fab:Vat";
  readonly placeholder = "fab:SelectVatDeductible";
  readonly searchPlaceholder = "fab:SearchVatDeductible";
  readonly emptyText = "fab:NoVatDeductibleFound";
  body = {};
  parameters = {};

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    return {
      options: VAT_DEDUCTIBLE_OPTIONS,
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
